module.exports = __webpack_public_path__ + "img/VOLKSWAGEN.ca573317.svg";